<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="600"
  >
    <a-form :model="formState" :rules="rules" ref="formRef">
      <a-form-item label="检查模块" name="checkModule">
        <a-select
          v-model:value="formState.checkModule"
          placeholder="请选择检查模块"
          :disabled="true"
        >
          <a-select-option value="区域状态标识">区域状态标识</a-select-option>
          <a-select-option value="仪器设备">仪器设备</a-select-option>
          <a-select-option value="工装工具">工装工具</a-select-option>
          <a-select-option value="在岗">在岗</a-select-option>
          <a-select-option value="5s">5s</a-select-option>
          <a-select-option value="其他违规">其他违规</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="检查内容" name="checkContent">
        <a-textarea
          v-model:value="formState.checkContent"
          placeholder="请输入检查内容"
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="检查结果" name="checkResults">
        <a-select
          v-model:value="formState.checkResults"
          placeholder="请选择检查结果"
        >
          <a-select-option :value="true">合格</a-select-option>
          <a-select-option :value="false">不合格</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="不合格原因"
        name="unqualifiedReason"
        v-if="formState.checkResults === false"
      >
        <a-textarea
          v-model:value="formState.unqualifiedReason"
          placeholder="请输入不合格原因"
          auto-size
        ></a-textarea>
      </a-form-item>

      <a-form-item
        label="员工态度"
        name="employeeAttitude"
        v-if="formState.checkResults === false"
      >
        <a-select
          v-model:value="formState.employeeAttitude"
          placeholder="请选择员工态度"
        >
          <a-select-option value="诚恳">诚恳</a-select-option>
          <a-select-option value="不接受">不接受</a-select-option>
          <a-select-option value="勉强接受">勉强接受</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="批评教育"
        name="isEducation"
        v-if="formState.checkResults === false"
      >
        <a-select
          v-model:value="formState.isEducation"
          placeholder="请选是否择批评教育"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="培训"
        name="isTrain"
        v-if="formState.checkResults === false"
      >
        <a-select
          v-model:value="formState.isTrain"
          placeholder="请选择是否培训"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="图片">
        <upload-img-vue
          ref="imgRef"
          :attachment="formState.picture"
          :requestFn="uploadProduceAttachment"
        ></upload-img-vue>
      </a-form-item>
      <a-form-item label="视频">
        <upload-video-vue
          ref="videoRef"
          :attachment="formState.video"
          :requestFn="uploadProduceAttachment"
        ></upload-video-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateStationCheck,
  uploadProduceAttachment,
} from "@/request/view/product";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  props: {
    type: String,
    produceOrTpc: String,
  },
  components: { uploadImgVue, uploadVideoVue },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();

    const formState = reactive({
      id: null,
      checkModule: null,
      checkContent: null,
      localDate: null,
      checkResults: null,
      picture: null,
      produceOrTpc: null,
      unqualifiedReason: null,
      video: null,
      isEducation: null,
      project: "swan",
      employeeAttitude: null,
      isTrain: null,
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      checkModule: [
        {
          required: true,
          message: "请选择检查模块",
          trigger: "change",
          type: "any",
        },
      ],
      checkContent: [
        {
          required: true,
          message: "请输入检查内容",
          trigger: "change",
          type: "any",
        },
      ],
      checkResults: [
        {
          required: true,
          message: "请输入检查结果",
          trigger: "change",
          type: "any",
        },
      ],
      // unqualifiedReason: [
      //   {
      //     required: true,
      //     message: "请输入不合格原因",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // isEducation: [
      //   {
      //     required: true,
      //     message: "请选择批评教育",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // employeeAttitude: [
      //   {
      //     required: true,
      //     message: "请选择员工态度",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // isTrain: [
      //   {
      //     required: true,
      //     message: "请输入培训",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      modalConfig.title = "编辑工位检查";
      Object.keys(formState).forEach((key) => {
        formState[key] = data[key];
      });
      formState.produceOrTpc = props.produceOrTpc;
      const { id, username } = store.state.user.user;
      if (!formState.localDate)
        formState.localDate = timeStampToTime("", "upload");
      if (!formState.userId) formState.userId = id;
      if (!formState.username) formState.username = username;
      if (!formState.type) formState.type = props.type;
      if (!formState.project) formState.project = "swan";
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            showUploading();
            await imgRef.value
              .uploadFile()
              .then((res) => {
                formState.picture = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await videoRef.value
              .uploadFile()
              .then((res) => {
                formState.video = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await saveOrUpdateStationCheck(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      rules,
      isEdit,
      imgRef,
      videoRef,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
